export const MessageType = {
	Info: 'INFO',
	Error: 'ERROR',
	Warn: 'WARN',
	Success: 'SUCCESS',
};
